<template>
  <v-app>
    <Header
        v-if="$route.path.indexOf('sub')<1"
        :style="
        $vuetify.breakpoint.lgAndUp?'marginBottom:120px':''
"
    />
    <sub-header   class="mb-16" v-else :header-items="currentHeaderItems"/>
    <div v-if="breadcrumbItems && breadcrumbItems.length" class="breadcrumb-wrap black" :class="{'with-padding':($route.path.indexOf('sub') > -1)}">
      <v-breadcrumbs :items="breadcrumbItems"></v-breadcrumbs>
    </div>
    <!--v-show="$route.fullPath!=='/sub/light-blocks'"-->
    
    <v-main :class="this.$i18n.locale==='en'?'ltr':'rtl'">
      <router-view :key="$route.fullPath"/>
    </v-main>
    <foot/>
  </v-app>
</template>

<script>

import Header from "./components/header/Header";
import foot from "./components/footer/foot";
import {mapState} from "vuex";
import {
        CHECK_USER
} from "./store/authManagement/action_type";
export default {
  name: 'App',
  components: {foot, Header},
  computed:{
        ...mapState({
            lightweightBlockMenu:state => state.homeManagement.lightweightBlockMenu,
            materialHeaderMenu:state => state.homeManagement.materialHeaderMenu,
            glassHeaderMenu:state => state.homeManagement.glassHeaderMenu,
        }),
        lang(){
      return localStorage.getItem("lang")
    },
        breadcrumbItems(){
          let items=this.$route.meta.breadcrumbs;
          if(!items) return [];
          items=items.map(item=>{
            item.text=this.$t(item.text)
            return item;
          })
          return items;
        }
    },
  data() {
    return {
      // breadcrumbsitems: this.$route.meta.breadcrumbs,
      currentHeaderItems: [],
      lightBlockHeaderItems: [
        {
          name: 'صفحه اصلی',
          type: 'single',
          route: '/sub/light-blocks',
          subDomain: []
        },
        {
          name: 'درباره ما',
          type: 'single',
          route: '/sub/light-blocks/about',
          expanded: false,
        },
        {
          name: 'اخبار',
          type: 'single',
          route: '/sub/light-blocks/news',
          expanded: false,
        },
        {
          name: 'محصولات',
          type: 'sublayer',
          route: '',
          expanded: false,
          subDomain: [
            {
              name: 'بلوک سبک اتوکلاو شده',
              route: '/sub/light-blocks/construction/product/block'
            },
            {
              name: 'آجر سیلیکان',
              route: '/sub/light-blocks/construction/product/ajor'
            },
            {
              name: 'ملات خشک ساختمانی',
              route: '/sub/light-blocks/construction/products',
              expanded:false,
              sub:[
                {
                  pr: 'ملات عایق حرارت',
                  en: 'Heat Resistant Plaster',
                  img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                  url: 'topic/295',
                },
                {
                  pr: 'ملات اندودکاری (آستر)',
                  en: 'Plaster Mortar',
                  img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                  url: 'topic/294',
                },
                {
                  pr: 'ملات خود تراز شونده',
                  en: 'Self-leveling Mortar',
                  img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                  url: 'topic/293',
                },
                {
                  pr: 'چسب بلوک سبک AAC',
                  en: 'AAC',
                  img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                  url: 'topic/292',
                },
                {
                  pr: 'ملات ضد حریق',
                  en: 'Fireproof Mortar',
                  img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                  url: 'topic/299',
                },
                {
                  pr: 'ملات اندودکاری (اندود نهایی)',
                  en: 'Finishing Mortar',
                  img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                  url: 'topic/298',
                },
                {
                  pr: 'ملات عایق رطوبت',
                  en: 'Waterproof Mortar',
                  img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                  url: 'topic/297',
                },
                {
                  pr: 'چسب کاشی و سرامیک',
                  en: 'Tile and Ceramic Adhesiveُ',
                  img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                  url: 'topic/296',
                },
                {
                  pr: 'چسب آجرنما',
                  en: 'Facade Brick Adhesive',
                  img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                  url: 'topic/303',
                },
                {
                  pr: 'ملات بنایی',
                  en: 'Building Plaster',
                  img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                  url: 'topic/302',
                },
                {
                  pr: 'گروه صنعتی منبسط شونده',
                  en: 'Cement Expending Grout',
                  img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                  url: 'topic/301',
                },
                {
                  pr: 'پودر بندکشی',
                  en: 'Binding Powder',
                  img: require('@/assets/images/light_blocks_products/heat.jpeg'),
                  url: 'topic/300',
                },
              ],
            },
          ]
        },
        {
          name: 'اطلاعات فنی',
          type: 'single',
          expanded: false,
          route: '/sub/light-blocks/technical'
        },
        {
          name: 'شبکه عاملیت',
          type: 'single',
          route: '/sub/light-blocks/operation-network',
          expanded: false,

        },
        {
          name: 'تماس با ما',
          type: 'single',
          route: '/sub/light-blocks/contact-us',
          subDomain: []
        },

      ],
      materialHeaderItems: [
        {
          name: 'صفحه اصلی',
          type: 'single',
          route: '/',
          subDomain: []
        },
        {
          name: 'درباره ما',
          type: 'single',
          route: '/sub/material/about',
          expanded: false,
        },
        {
          name: 'اخبار',
          type: 'single',
          route: '/sub/material/news',
          expanded: false,
        },
        {
          name: 'محصولات',
          type: 'sublayer',
          route: '',
          expanded: false,
          subDomain: [
            {
              name: 'سیلیس',
              route: ''
            },
            {
              name: 'دولومیت',
              route: ''
            },
            {
              name: 'فلدسپار',
              route: ''
            },
            {
              name: 'کربنات کلسیم',
              route: ''
            },
            {
              name: 'کربنات سدیم',
              route: ''
            },
            {
              name: 'ماسه ریخته گری',
              route: ''
            },
          ]
        },
        {
          name: 'اطلاعات فنی',
          type: 'single',
          expanded: false,
          route: '/sub/material/technical'
        },
        {
          name: 'تماس با ما',
          type: 'single',
          route: '/sub/contact-us',
          subDomain: []
        },

      ],
      glassHeaderItems: [
        {
          name: 'صفحه اصلی',
          type: 'single',
          route: '/sub/glasses',
          subDomain: []
        },
        {
          name: 'درباره ما',
          type: 'single',
          route: '/sub/glass/about',
          expanded: false,
        },
        {
          name: 'اخبار',
          type: 'single',
          route: '/sub/glass/news',
          expanded: false,
        },
        {
          name: 'محصولات',
          type: 'sublayer',
          route: '',
          expanded: false,
          subDomain: [
            {
              name: 'شیشه فلوت',
              route: ''
            },
            {
              name: 'صنایع جانبی',
              route: ''
            },
            {
              name: 'شیشه های صنعتی',
              route: ''
            },
            {
              name: 'شیشه های High Performance',
              route: '/sub/cement-block'
            },
          ]
        },
        {
          name: 'اطلاعات فنی',
          type: 'single',
          expanded: false,
          route: '/sub/glass/technical',
        },
        {
          name: 'شبکه عاملیت',
          type: 'single',
          expanded: false,
          route: '/sub/glass/operation-network',
        },
        {
          name: 'تماس با ما',
          type: 'single',
          route: '/sub/contact-us',
          subDomain: []
        },

      ],
    }
  },
  methods: {
    checkCurrentPagePath() {
      console.log("current page",this.$route.path.indexOf('light-blocks'));
      if (this.$route.path.indexOf('light-blocks') > 0) {
        console.log("in lightblok",this.lightweightBlockMenu)
        this.currentHeaderItems = this.lightweightBlockMenu;
      }
     else if (this.$route.path.indexOf('material') > 0) {
        this.currentHeaderItems = this.materialHeaderMenu;
      } else {
        this.currentHeaderItems = this.glassHeaderMenu;
      }
    }
  },
  async mounted(){
    console.log(this.$route)
    if(this.lang == 'en'){
      console.log("ff")
      document.querySelector("#app").classList.remove('v-application--is-rtl');
      
    }
    // const data=await this.$store.dispatch('infoManagement/getWebsiteSettings');
    // console.log("settings",data)
    // document.getElementsByTagName("head")[0].innerHTML+=data.details.google_analytics_code;
  },  
  async created(){
    if(localStorage.getItem("lang")){
      this.$i18n.locale=localStorage.getItem("lang")
    }
    document.querySelector("html").setAttribute("lang",this.lang);
    if(this.lang == 'ar' || this.lang == 'fa' || this.lang == 'pr'){
      document.querySelector("html").setAttribute("dir","rtl");
    }else{
      document.querySelector("html").setAttribute("dir","ltr");
    }
    
    await this.$store.dispatch('homeManagement/getLightweightBlockMenu');
    await this.$store.dispatch('homeManagement/getMaterialHeaderItems');
    await this.$store.dispatch('homeManagement/getGlassHeaderMenu');
    this.checkCurrentPagePath();
    
    this.$store.dispatch(`authManagement/${CHECK_USER}`);
  },
  watch:{
    '$route':{
      handler:function (){
        this.checkCurrentPagePath();
      }
    }
  }
};
</script>
<style>
@import "assets/style.css";

.rtl {
  direction: rtl !important;
}

.ltr {
  direction: ltr !important;
}
.breadcrumb-wrap{
  padding: 0 1rem;
}
.v-breadcrumbs{
  padding: 8px 12px 5px 12px !important;
  
}
.v-breadcrumbs a{
  color: #fff !important;
}
.v-breadcrumbs__divider{
  color: #fff !important;
}
.breadcrumb-wrap.with-padding{
  margin-top: 4rem;
}
</style>
